import { MAP_CENTER } from '../v2_actions/map'
const initialState = {
    mapInfo: {
        showAddress: false,
        position: { lat: -31.364637526600113, lng: 24.70517530697458 },
        // address: "Click to Enter Exact Location of Shoot",
        address: false,
        zoom: 11,
        mapLink: `https://maps.googleapis.com/maps/api/js?key=${window.LOCAL_SETTINGS.GOOGLE_MAP_KEY}&v=3.exp&libraries=geometry,drawing,places`,
    },
}

export default function MapInfo(state = initialState, action) {
    switch (action.type) {
        case "MAPINFO/SETMAPINFO":
            return {
                ...state,
                mapInfo: action.mapInfo,
            }
        case MAP_CENTER:
            return {
                ...state,
                center: {lat: action.lat, lng: action.lng}
            }
        default:
            return state
    }
}
